import {
	BackdropCircularProgress,
	EnhancedDivider,
	EnhancedDropDownRHF,
	EnhancedDropDownRHFWithLabel,
	EnhancedSnackbar,
	EnhancedTextAreaFieldRHF,
	FlatStandardPanel,
	IResponse,
	IServerError,
	ITest,
	LabelPosition,
	RHookFormTextField,
	RequiredAsterisk,
	SingleColumnLayout,
	Spacer,
} from "@websential/cosmic-v20";
import {
	Box,
	Button,
	Divider,
	Grid,
	InputLabel,
	Paper,
	Typography,
} from "@mui/material";
import {
	DifferencePanel,
	EmployerDetailPanel,
	T4SlipDetailPanel,
	TotalBalancePanel,
} from "./Panels";
import {
	EnhancedDialog,
	EnhancedLinkButton,
	IconTextButton,
	RouterLinkButton,
	SplitButton,
} from "@websential/cosmic-v20";
import { FC, useEffect, useMemo, useState } from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import {
	INITIAL_SNACKBAR_DATA,
	T4_SUMMARY_RESUCED_EI_SCREEN_SLUG,
} from "../../../common/constants";
import {
	isLoadingselectedSlipType,
	selectedSlipType,
} from "../../TaxSlipFilingResource";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { ClientService } from "../../../services";
import FileSaver from "file-saver";
import { IAppState } from "../../../store/reducers";
import { InvoiceDialogPanel } from "../T4SlipList/InvoiceDialogPanel";
import { PrintingService } from "../../../services/PrintingService";
import { ReportsService } from "../../../services/ReportsService";
import { T4SlipService } from "../../../services/T4SlipService";
import { T4SummarySetupSchema } from "../T4SlipSummarySetup/summaryValidate";
import { T4SummaryToolbar } from "../T4SummaryToolbar";
import { TaxSlipAccountInformation } from "../../TaxSlipAccountInformation";
import { TaxSlipSummaryDataInput } from "../../TaxSlipSummaryDataInput";
import { checkSummaryType } from "../T4SlipSummarySetup";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { setSelectedINVOICE } from "../../../store/actions/invoiceReportActions";
import { scrollPanelFieldsToTop, useNavigateToLogout } from "../../../common/Common";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IT4SlipSummaryReducedEISetup extends ITest { }
export let selectedT4SummaryReduceEIType: any = 400;

const T4_SUMMARY_DATA_QUERY_KEY = "get-t4-summary-data";
const useGetT4SummaryReduceEIData = (
	clientid: string,
	slipType: string | number,
	taxYear: number
) =>
	useQuery({
		queryKey: [T4_SUMMARY_DATA_QUERY_KEY, clientid, slipType, taxYear],
		queryFn: (data) => {
			return T4SlipService.getT4SummaryReduceEI(clientid, slipType, taxYear);
		},
		refetchOnWindowFocus: false,
	});

const useGetTransmitterDDL = (clientId: string, taxYear: number) =>
	useQuery({
		queryKey: ["transmitters"],
		queryFn: () => {
			return T4SlipService.getAllActiveTransmittersByClientIdAndTaxYear(
				clientId,
				taxYear
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetIssuerDDL = (clientId: string, taxYear: number) =>
	useQuery({
		queryKey: ["Issuers"],
		queryFn: () => {
			return T4SlipService.getAllActiveIssuersByClientIdAndTaxYear(
				clientId,
				taxYear
			);
		},
		refetchOnWindowFocus: false,
	});
const useGetContactPersonDDL = (clientId: string, taxYear: number) =>
	useQuery({
		queryKey: ["contact-person"],
		queryFn: () => {
			return T4SlipService.getAllActiveContactPersonsByClientIdAndTaxYear(
				clientId,
				taxYear
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetSlipIds = (tag: string, clientId: string, taxYear: number) =>
	useQuery({
		queryKey: ["get-slip-ids", tag, clientId, taxYear],
		queryFn: (data) => {
			return T4SlipService.getSlipIds(tag, clientId, taxYear);
		},
		refetchOnWindowFocus: false,
	});

const useGetCompanyData = (
	id: string | undefined,
	navigateToLogout: (path: any) => void
) =>
	useQuery({
		queryKey: ["client-get-by-id", id],
		queryFn: (data) => {
			return ClientService.getById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

export const T4SlipSummaryReducedEISetup: FC<IT4SlipSummaryReducedEISetup> = ({
	testId,
}) => {
	const [snackbarData, setSnackbarData] = useState<any>(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const dispatch = useDispatch();
	const navigateToLogout = useNavigateToLogout();
	const clientId = useSelector((state: IAppState) => state.client.id);
	const clientName = useSelector((state: IAppState) => state.client.clientName);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const [SummaryResponseToPass, setSummaryResponseToPass] =
		useState<any>(undefined);
	const [openInvoiceDialog, setInvoiceDialogOpen] = useState(false);
	const [invoiceData, setInvoiceData] = useState<any>([]);
	const [isPendingData, setIsPendingData] = useState(false);
	const [invoicePaymentFor, setInvoicePaymentFor] = useState(10);

	const [selectedType, setSelectedType] = useState(400);
	const [selectedIssuer, setSelectedIssuer] = useState("");
	const [selectedContactPerson, setSelectedContactPerson] = useState("");
	const [isPendingIssuerSelect, setIsPendingIssuerSelect] = useState(false);

	const maskedStatus: any = sessionStorage.getItem("maskEnabled");

	const formMethods = useForm<any>({
		resolver: yupResolver(T4SummarySetupSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		// defaultValues: DEFAULT_VALUES,
	});

	const { isPending: isSubmitting, mutate: submitFormData } = useMutation({
		mutationFn: T4SlipService.createT4SummaryReducedEI,

		onSuccess: (res: any | IServerError | IResponse | any) => {
			if (res.status === 201 || res.status === 200) {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				scrollPanelFieldsToTop();
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message
							? res.message
							: res.data.message
								? res.data.message
								: "Something went wrong!",
					severity: "error",
				});
			}
		},
		onError: (err: any) => {
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const {
		isPending: isPendingSummaryGetData,
		isFetching: reFetchingSlipType,
		refetch: refetchSlipType,
		data: t4SummaryReduceEIData,
	} = useGetT4SummaryReduceEIData(clientId, selectedType, taxYear);


	/**
	 * Handle when the form is submitted.
	 *
	 * @param {IFlexFieldSetupRequest} formData
	 */

	const onSubmit = (formData: any) => {
		let Payload = {
			id: clientId,
			taxYear: taxYear,
			minusRemittance:
				formData.minusRemittance === null || ""
					? undefined
					: formData.minusRemittance,
			slipType: selectedType,
			confirmationCode:
				formData.confirmationCode !== ""
					? formData.confirmationCode
					: undefined,
			notes: formData.notes !== "" ? formData.notes : undefined,
			transmitter: formData.valueOfTransmitter,
			issuer: formData.valueOfIssuer,
			contactPerson: formData.valueOfContactPerson,
		};
		submitFormData(Payload);

	};

	const onCloseHandler = () => {
		setInvoiceDialogOpen(false);
	};

	const saveXmlAsFile = (xmlData: any, filename: any) => {
		const blob = new Blob([xmlData], { type: "xml;charset=utf-8" });
		FileSaver.saveAs(blob, filename);
	};
	const onGenerateXMLClicked = async (): Promise<void> => {
		setIsPendingData(true);
		if (maskedStatus === "true") {
			setIsPendingData(false);
			setSnackbarData({
				open: true,
				message: "Please unmask your data.",
				severity: "error",
			});
		} else if (
			t4SummaryReduceEIData &&
			t4SummaryReduceEIData.transmitter === null &&
			t4SummaryReduceEIData.issuer === null &&
			t4SummaryReduceEIData.contactPerson === null
		) {
			setIsPendingData(false);
			setSnackbarData({
				open: true,
				message:
					"Please select and submit transmitter, issuer and contact person.",
				severity: "error",
			});
		} else {
			if (invoicePaymentFor === 10) {
				try {
					const previousYearInvoiceResponse: any =
						await ReportsService.getPreviousYearInvoice(clientId, taxYear - 1);
					try {
						const response: any = await ReportsService.createInvoice(
							clientId,
							taxYear
						);
						setIsPendingData(false);

						if (
							previousYearInvoiceResponse.message ===
							"Slips not found for invoice." &&
							response.message === "Slips not found for invoice."
						) {
							if (
								t4SlipIds &&
								t4SlipIds.generalAuditStatus !== null &&
								t4SlipIds.generalAuditStatus === true &&
								t4SlipIds &&
								t4SlipIds.auditStatus !== null &&
								t4SlipIds.auditStatus === true
							) {
								setIsPendingData(true);
								try {
									const response: any = await PrintingService.createT4Xml(
										clientId,
										400,
										taxYear,
										true,
									);
									if (response.status === 400) {
										setSnackbarData({
											open: true,
											message: response.data.message
												? response.data.message
												: "Something went wrong.",
											severity: "error",
										});
									} else {
										const filename = `T4Summaryxml-${clientName}.xml`;
										saveXmlAsFile(response, filename);
									}
									setIsPendingData(false);
								} catch (err) {

									alert(err);
								}
								// }
								setIsPendingData(false);
							} else {
								setIsPendingData(false);
								setSnackbarData({
									open: true,
									message: (
										<>
											Please load Audit in the menu, press Run T4 Audit and
											clear all audit items (Audit Filing and PIER Review) to
											generate documents.{" "}
											<a
												href="https://appv3.taxslips.com/#/audit/filing"
												style={{
													color: "#aa1010",
													textDecoration: "none",
													fontWeight: "bold",
												}}
											>
												Click here to view
											</a>
										</>
									),
									severity: "error",
									autoHide: false,
								});
							}
						} else if (
							response?.id != null &&
							previousYearInvoiceResponse?.id != null
						) {

							setInvoiceData([previousYearInvoiceResponse, response]);
							setInvoiceDialogOpen(true);
						} else if (
							previousYearInvoiceResponse?.id != null &&
							response?.message === "Slips not found for invoice."
						) {

							setInvoiceData([previousYearInvoiceResponse]);
							setInvoiceDialogOpen(true);
						} else if (
							response?.id != null &&
							previousYearInvoiceResponse?.message ===
							"Slips not found for invoice."
						) {

							setInvoiceData([response]);
							setInvoiceDialogOpen(true);
						} else {
							setSnackbarData({
								open: true,
								message: "Something went wrong.",
								severity: "error",
							});
						}
						setIsPendingData(false);
					} catch (err) {

						setIsPendingData(false);
					}
				} catch (err) {

					setIsPendingData(false);
				}
			} else {
				try {
					const response: any = await ReportsService.createInvoice(
						clientId,
						taxYear
					);
					setIsPendingData(false);

					if (response.message === "Slips not found for invoice.") {
						// setIsPendingData(true);
						// try {
						//   const filingAuditResponse: any = await T4SlipService.getT4AuditFiling(
						//     clientId,
						//     taxYear
						//   );
						//   
						//   if (
						//     filingAuditResponse &&
						//     filingAuditResponse.general_filling &&
						//     filingAuditResponse.general_filling.length > 0
						//   ) {
						//   
						//     setSnackbarData({
						//       open: true,
						//       message: (
						//         <>
						//           Please load Audit in the menu and clear all audit items (Audit
						//           Filing and PIER Review) to generate documents.{" "}
						//           <a
						//             href="https://appv3.taxslips.com/#/audit/filing"
						//             style={{
						//               color: "#aa1010",
						//               textDecoration: "none",
						//               fontWeight: "bold",
						//             }}
						//           >
						//             Click here to view
						//           </a>
						//         </>
						//       ),
						//       severity: "error",
						//       autoHide: false,
						//     });
						//   } else if (
						//     filingAuditResponse &&
						//     filingAuditResponse.t4_filling &&
						//     filingAuditResponse.t4_filling.length > 0
						//   ) {
						//    
						//     setSnackbarData({
						//       open: true,
						//       message: (
						//         <>
						//           Please load Audit in the menu and clear all audit items (Audit
						//           Filing and PIER Review) to generate documents.{" "}
						//           <a
						//             href="https://appv3.taxslips.com/#/audit/filing"
						//             style={{
						//               color: "#aa1010",
						//               textDecoration: "none",
						//               fontWeight: "bold",
						//             }}
						//           >
						//             Click here to view
						//           </a>
						//         </>
						//       ),
						//       severity: "error",
						//       autoHide: false,
						//     });
						//   } else {
						if (
							t4SlipIds &&
							t4SlipIds.generalAuditStatus !== null &&
							t4SlipIds.generalAuditStatus === true &&
							t4SlipIds &&
							t4SlipIds.auditStatus !== null &&
							t4SlipIds.auditStatus === true
						) {
							setIsPendingData(true);
							try {
								const response: any = await PrintingService.createT4Xml(
									clientId,
									400,
									taxYear,
									false,
								);
								if (response.status === 400) {
									setSnackbarData({
										open: true,
										message: response.data.message
											? response.data.message
											: "Something went wrong.",
										severity: "error",
									});
								} else {
									const filename = `T4Summaryxml-${clientName}.xml`;
									saveXmlAsFile(response, filename);
								}
								setIsPendingData(false);
							} catch (err) {

								alert(err);
							}
							// }
							setIsPendingData(false);
						} else {
							setIsPendingData(false);
							setSnackbarData({
								open: true,
								message: (
									<>
										Please load Audit in the menu, press Run T4 Audit and clear
										all audit items (Audit Filing and PIER Review) to generate
										documents.{" "}
										<a
											href="https://appv3.taxslips.com/#/audit/filing"
											style={{
												color: "#aa1010",
												textDecoration: "none",
												fontWeight: "bold",
											}}
										>
											Click here to view
										</a>
									</>
								),
								severity: "error",
								autoHide: false,
							});
						}
						// } catch (err: any) {
						//   setIsPendingData(false);
						//   alert(err);
						// }
					} else if (response && response.id !== null) {
						setInvoiceData([response]);
						setInvoiceDialogOpen(true);
					} else {
						setSnackbarData({
							open: true,
							message: "Something went wrong.",
							severity: "error",
						});
					}
					setIsPendingData(false);
				} catch (err) {

					setIsPendingData(false);
				}
			}
		}
	};
	const savePdfAsFile = (pdfData: any, filename: any) => {
		const blob = new Blob([pdfData], { type: "application/pdf" });
		FileSaver.saveAs(blob, filename);
	};
	const onPrintClicked = async (): Promise<void> => {
		setIsPendingData(true);
		const maskedStatus: any = sessionStorage.getItem("maskEnabled");
		if (maskedStatus === "true") {
			setIsPendingData(false);
			setSnackbarData({
				open: true,
				message: "Please unmask your data.",
				severity: "error",
			});
		} else if (
			t4SummaryReduceEIData &&
			t4SummaryReduceEIData.issuer === null &&
			t4SummaryReduceEIData.contactPerson === null
		) {
			setIsPendingData(false);
			setSnackbarData({
				open: true,
				message: "Please select and submit issuer and contact person.",
				severity: "error",
			});
		} else {
			if (invoicePaymentFor === 10) {
				try {
					const previousYearInvoiceResponse: any =
						await ReportsService.getPreviousYearInvoice(clientId, taxYear - 1);
					try {
						const response: any = await ReportsService.createInvoice(
							clientId,
							taxYear
						);
						setIsPendingData(false);

						if (
							previousYearInvoiceResponse.message ===
							"Slips not found for invoice." &&
							response.message === "Slips not found for invoice."
						) {
							if (
								t4SlipIds &&
								t4SlipIds.generalAuditStatus !== null &&
								t4SlipIds.generalAuditStatus === true &&
								t4SlipIds &&
								t4SlipIds.auditStatus !== null &&
								t4SlipIds.auditStatus === true
							) {
								setIsPendingData(true);
								try {
									const response: any =
										await PrintingService.createT4SummaryPdfPrint(
											clientId,
											400,
											true,
											taxYear
										);
									if (response.status === 400) {
										setSnackbarData({
											open: true,
											message: response.data.message
												? response.data.message
												: "Something went wrong.",
											severity: "error",
										});
									} else {
										const filename = `T4Summary-${clientName}.pdf`;
										savePdfAsFile(response, filename);
									}
									setIsPendingData(false);
								} catch (err) {

									alert(err);
								}
								// }
								setIsPendingData(false);
							} else {
								setIsPendingData(false);
								setSnackbarData({
									open: true,
									message: (
										<>
											Please load Audit in the menu, press Run T4 Audit and
											clear all audit items (Audit Filing and PIER Review) to
											generate documents.{" "}
											<a
												href="https://appv3.taxslips.com/#/audit/filing"
												style={{
													color: "#aa1010",
													textDecoration: "none",
													fontWeight: "bold",
												}}
											>
												Click here to view
											</a>
										</>
									),
									severity: "error",
									autoHide: false,
								});
							}
						} else if (
							response?.id != null &&
							previousYearInvoiceResponse?.id != null
						) {

							setInvoiceData([previousYearInvoiceResponse, response]);
							setInvoiceDialogOpen(true);
						} else if (
							previousYearInvoiceResponse?.id != null &&
							response?.message === "Slips not found for invoice."
						) {

							setInvoiceData([previousYearInvoiceResponse]);
							setInvoiceDialogOpen(true);
						} else if (
							response?.id != null &&
							previousYearInvoiceResponse?.message ===
							"Slips not found for invoice."
						) {

							setInvoiceData([response]);
							setInvoiceDialogOpen(true);
						} else {
							setSnackbarData({
								open: true,
								message: "Something went wrong.",
								severity: "error",
							});
						}
						setIsPendingData(false);
					} catch (err) {

						setIsPendingData(false);
					}
				} catch (err) {

					setIsPendingData(false);
				}
			} else {
				try {
					const response: any = await ReportsService.createInvoice(
						clientId,
						taxYear
					);
					setIsPendingData(false);

					if (response.message === "Slips not found for invoice.") {
						setIsPendingData(true);
						// try {
						//   const filingAuditResponse: any =
						//     await T4SlipService.getT4AuditFiling(clientId, taxYear);

						//   if (
						//     filingAuditResponse &&
						//     filingAuditResponse.general_filling &&
						//     filingAuditResponse.general_filling.length > 0
						//   ) {

						//     setSnackbarData({
						//       open: true,
						//       message: (
						//         <>
						//           Please load Audit in the menu and clear all audit items
						//           (Audit Filing and PIER Review) to generate documents.{" "}
						//           <a
						//             href="https://appv3.taxslips.com/#/audit/filing"
						//             style={{
						//               color: "#aa1010",
						//               textDecoration: "none",
						//               fontWeight: "bold",
						//             }}
						//           >
						//             Click here to view
						//           </a>
						//         </>
						//       ),
						//       severity: "error",
						//       autoHide: false,
						//     });
						//   } else if (
						//     filingAuditResponse &&
						//     filingAuditResponse.t4_filling &&
						//     filingAuditResponse.t4_filling.length > 0
						//   ) {
						//
						//     setSnackbarData({
						//       open: true,
						//       message: (
						//         <>
						//           Please load Audit in the menu and clear all audit items
						//           (Audit Filing and PIER Review) to generate documents.{" "}
						//           <a
						//             href="https://appv3.taxslips.com/#/audit/filing"
						//             style={{
						//               color: "#aa1010",
						//               textDecoration: "none",
						//               fontWeight: "bold",
						//             }}
						//           >
						//             Click here to view
						//           </a>
						//         </>
						//       ),
						//       severity: "error",
						//       autoHide: false,
						//     });
						//   } else {
						//     setIsPendingData(true);
						if (
							t4SlipIds &&
							t4SlipIds.generalAuditStatus !== null &&
							t4SlipIds.generalAuditStatus === true &&
							t4SlipIds &&
							t4SlipIds.auditStatus !== null &&
							t4SlipIds.auditStatus === true
						) {
							setIsPendingData(true);
							try {
								const response: any =
									await PrintingService.createT4SummaryPdfPrint(
										clientId,
										400,
										true,
										taxYear
									);
								if (response.status === 400) {
									setSnackbarData({
										open: true,
										message: response.data.message
											? response.data.message
											: "Something went wrong.",
										severity: "error",
									});
								} else {
									const filename = `T4Summary-${clientName}.pdf`;
									savePdfAsFile(response, filename);
								}
								setIsPendingData(false);
							} catch (err) {

								alert(err);
							}
							// }
							setIsPendingData(false);
						} else {
							setIsPendingData(false);
							setSnackbarData({
								open: true,
								message: (
									<>
										Please load Audit in the menu, press Run T4 Audit and clear
										all audit items (Audit Filing and PIER Review) to generate
										documents.{" "}
										<a
											href="https://appv3.taxslips.com/#/audit/filing"
											style={{
												color: "#aa1010",
												textDecoration: "none",
												fontWeight: "bold",
											}}
										>
											Click here to view
										</a>
									</>
								),
								severity: "error",
								autoHide: false,
							});
						}
						// } catch (err: any) {
						//   setIsPendingData(false);
						//   alert(err);
						// }
					} else if (response && response.id !== null) {
						setInvoiceData([response]);
						setInvoiceDialogOpen(true);
					} else {
						setSnackbarData({
							open: true,
							message: "Something went wrong.",
							severity: "error",
						});
					}
					setIsPendingData(false);
				} catch (err) {

					setIsPendingData(false);
				}
			}
		}
	};

	const onDeleteClicked = async (): Promise<void> => {
		//delete confirmation code
		try {
			setIsPendingData(true);
			const response: any =
				await T4SlipService.t4SummaryReduceEIclearConfirmationCode(
					clientId,
					checkSummaryType(
						t4SummaryReduceEIData && t4SummaryReduceEIData.slipType
					),
					taxYear
				);

			if (response.status === 200) {
				setSnackbarData({
					open: true,
					message: response.data.message,
					severity: "success",
				});
				scrollPanelFieldsToTop();
				refetchSlipType();
			} else {
				setSnackbarData({
					open: true,
					message:
						response &&
							response.message !== undefined &&
							typeof (response.message && response.message) !== "object"
							? response.message && response.message
							: response.message.message
								? response.message.message
								: "Something went wrong!",
					severity:
						response.status === false
							? "error"
							: response.success === false
								? "error"
								: "success",
				});
			}
			setIsPendingData(false);
		} catch (err) {
			setIsPendingData(false);

		}
	};

	/**
	 * On Snackbar closed.
	 *
	 * @param {React.SyntheticEvent | Event} event
	 * @param {string} reason
	 */
	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useEffect(() => {

		// if the selected flex field data has loaded.
		if (
			t4SummaryReduceEIData &&
			t4SummaryReduceEIData.message
			//&& t4SummaryReduceEIData.message.status_code === 404
		) {

			formMethods.reset();
			formMethods.setValue("totalNumberOfT4SlipsFiled", 0);
			formMethods.setValue("employmentIncome", null);
			formMethods.setValue("registerPensionPlanRppContribution", null);
			formMethods.setValue("pensionAdjustment", null);
			formMethods.setValue("employeesCppContribution", null);
			formMethods.setValue("employeesSecondCppContribution", null);
			formMethods.setValue("employersCppContribution", null);
			formMethods.setValue("employersSecondCppContribution", null);
			formMethods.setValue("employeesEiContribution", null);
			formMethods.setValue("employersEiContribution", null);
			formMethods.setValue("incomeTaxDeducted", null);
			formMethods.setValue("totalDeductionReported", null);
			formMethods.setValue("difference", null);
			formMethods.setValue("overpayment", null);
			formMethods.setValue("balanceDue", null);
			formMethods.setValue("minusRemittance", null);
			setSnackbarData({
				open: true,
				message:
					t4SummaryReduceEIData && t4SummaryReduceEIData.message
						? t4SummaryReduceEIData.message.message
						: "Something went wrong!",
				severity: "error",
				autoHide: true,
			});
		} else if (t4SummaryReduceEIData) {
			Object.keys(t4SummaryReduceEIData).forEach((fieldName) => {
				// @ts-ignore
				const fieldValue = t4SummaryReduceEIData[fieldName];
				// @ts-ignore
				formMethods.setValue(fieldName, fieldValue ?? undefined);


				// set all values to decimal
				if (fieldName === "registerPensionPlanRppContribution") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "employmentIncome") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "pensionAdjustment") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "employeesCppContribution") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "employeesSecondCppContribution") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "employersCppContribution") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "employersSecondCppContribution") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "employeesEiContribution") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "employersEiContribution") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "incomeTaxDeducted") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "totalDeductionReported") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "difference") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "overpayment") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "balanceDue") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "minusRemittance") {
					fieldValue !== null || undefined
						? formMethods.setValue(fieldName, fieldValue)
						: formMethods.setValue(fieldName, null);
				}
				if (fieldName === "transmitter") {
					formMethods.setValue("valueOfTransmitter", fieldValue);
				}
				if (fieldName === "issuer") {
					formMethods.setValue("valueOfIssuer", fieldValue);
				}
				if (fieldName === "contactPerson") {
					formMethods.setValue("valueOfContactPerson", fieldValue);
				}
				if (fieldName === "ownerSin1") {
					formMethods.setValue(
						fieldName,
						fieldValue
							? fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")
							: undefined
					);
				}
				if (fieldName === "ownerSin2") {
					formMethods.setValue(
						fieldName,
						fieldValue
							? fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")
							: undefined
					);
				}
				if (fieldName === "phone1") {
					formMethods.setValue(
						fieldName,
						fieldValue
							? fieldValue.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
							: undefined
					);
				}
			});
		}
	}, [t4SummaryReduceEIData, formMethods.setValue, formMethods]);

	useEffect(() => {
		if (selectedSlipType) {
			refetchSlipType();
		}
	}, [refetchSlipType, selectedSlipType]);

	const onSlipTypeSelectionChangeHandler = (e: any) => {
		setSelectedType(e.value);

		const selectedType = e.value;
		selectedT4SummaryReduceEIType = selectedType;
	};

	const { isPending: isPendingTransmitterDDL, data: transmitterDDL } =
		useGetTransmitterDDL(clientId, taxYear);


	const { isPending: isPendingIssuerDDL, data: issuerDDL } = useGetIssuerDDL(
		clientId,
		taxYear
	);


	const { isPending: isPendingContactPersonDDL, data: contactPersonDDL } =
		useGetContactPersonDDL(clientId, taxYear);


	const { isPending: loadingSlipIds, data: t4SlipIds } = useGetSlipIds(
		"T4",
		clientId,
		taxYear
	);

	const { isPending: isPendingClientDataById, data: companyGetByIdRecord } =
		useGetCompanyData(clientId, navigateToLogout);

	useEffect(() => {

		if (companyGetByIdRecord && companyGetByIdRecord.metaFields) {
			const paymentFor = companyGetByIdRecord.metaFields.find(
				(item: any) => item.name === "invoice_payment_for"
			);

			setInvoicePaymentFor(paymentFor ? parseInt(paymentFor.value) : 10);
		}
	}, [companyGetByIdRecord]);

	//when isssuer selection chanhe sin1 abd sin 2 would be updated by using get by id of filing ewsource
	const onIssuerSelectionChangeHandler = async (
		selectedItem: any
	): Promise<void> => {


		try {
			setIsPendingIssuerSelect(true);
			setTimeout(() => {
				setIsPendingIssuerSelect(false);
			}, 1000);
			const response = await T4SlipService.getIssuerDataById(
				selectedItem.value,
				clientId
			);


			setSelectedIssuer(response);
		} catch (err) {

			// alert(err);
		}
	};
	//update value of sin1 and sin 2
	useEffect(() => {
		if (selectedIssuer) {
			Object.keys(selectedIssuer).forEach((fieldName) => {
				// @ts-ignore
				const fieldValue = selectedIssuer[fieldName];
				// @ts-ignore
				if (fieldName === "ownerSin1") {
					formMethods.setValue(
						fieldName,
						fieldValue
							? fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")
							: undefined
					);
				}
				if (fieldName === "ownerSin2") {
					formMethods.setValue(
						fieldName,
						fieldValue
							? fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")
							: undefined
					);
				}
			});
		}
	}, [selectedIssuer, formMethods.setValue, formMethods]);

	//when Contact Person selection chanhe sin1 abd sin 2 would be updated by using get by id of filing ewsource
	const onContactPersonSelectionChangeHandler = async (
		selectedItem: any
	): Promise<void> => {


		try {
			setIsPendingIssuerSelect(true);
			setTimeout(() => {
				setIsPendingIssuerSelect(false);
			}, 1000);
			const response = await T4SlipService.getContactPersonDataById(
				selectedItem.value,
				clientId
			);


			setSelectedContactPerson(response);
		} catch (err) {

			// alert(err);
		}
	};
	//update value of sin1 and sin 2
	useEffect(() => {
		if (selectedContactPerson) {
			Object.keys(selectedContactPerson).forEach((fieldName) => {
				// @ts-ignore
				const fieldValue = selectedContactPerson[fieldName];
				// @ts-ignore
				if (fieldName === "phone1") {
					formMethods.setValue(
						fieldName,
						fieldValue
							? fieldValue.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
							: undefined
					);
				}
			});
		}
	}, [selectedContactPerson, formMethods.setValue, formMethods]);

	// setSummaryResponseToPass(12121212)

	const onUnPaidClickHandler = (clickedRow: any, tag: string) => {
		setIsPendingData(true);
		// setTimeout(() => {
		//   setIsPendingData(false);
		// }, 2500);
		const fetchData = async () => {
			try {
				const response: any =
					await ReportsService.paypalIntegrationOfUnpaidInvoice(
						clientId,
						clickedRow.refNo,
						tag
					);
				setIsPendingData(false);

				if (tag === "paypal") {
					window.open(response, "_blank");
				} else {
					window.open(response.message, "_blank");
				}
			} catch (error) {
				setIsPendingData(false);
				console.error("Error fetching data:", error);
			} finally {
				setIsPendingData(false);
			}
		};
		fetchData();

	};

	const onClickInvoiceNoHandler = (clickedRow: any) => {
		dispatch(setSelectedINVOICE(clickedRow));

	};

	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);

	const expandedLabels = ["Compliance", "T4"];
	const expandedT4SummaryReducedEIItem = "Summary Reduced EI";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (parentLabel === "T4" && item.label === expandedT4SummaryReducedEIItem) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedT4SummaryReducedEIItem && "/compliance/t4/summary-reduced-ei",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: T4_SUMMARY_RESUCED_EI_SCREEN_SLUG,
				companyName: clientName,
				activityType:
					"activity_type=updated&activity_type=delete&activity_type=print&activity_type=print_xml",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	return (
		<Grid
			size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
		// sx={{ "& .MuiAppBar-root": { zIndex: 2, top: "65px" } }}
		>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					isPendingSummaryGetData ||
					reFetchingSlipType ||
					isLoadingselectedSlipType ||
					isPendingTransmitterDDL ||
					isPendingIssuerDDL ||
					isPendingContactPersonDDL ||
					isPendingIssuerSelect ||
					isPendingData
				}
				testId={testId}
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid
							size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
							sx={{
								borderRadius: "3px",
							}}
						>
							<SingleColumnLayout
								showFullDiaplay={true}
								toolbar={
									<T4SummaryToolbar
										isSubmitting={isSubmitting}
										onGenerateXMLClicked={onGenerateXMLClicked}
										onPrintClicked={onPrintClicked}
										onDeleteClicked={onDeleteClicked}
										SummaryResponseToPass={SummaryResponseToPass}
										pageTitle={"Reduced EI"} t4SlipSummaryScreenPermissions={undefined} />
								}
								testId="t4-slip-summary-setup-form"
							>
								<Paper>
									<FlatStandardPanel
										title="Account Information"
										testId={`${testId}-account-information-panel`}
										showTitle={false}
										topPadding={3}
										leftSpacing={2}
										rightSpacing={2}
									>
										<TaxSlipAccountInformation
											logoURL={`${import.meta.env.BASE_URL
												}/images/cra_logo.png`}
											accountIdentifierTitle="Employer's account number"
											accountIdentifier="121212120RP0001"
											accountInformationMessage="You have to file your T4 information return on or before the last day of February."
											accountName="HELLOFRESH"
											accountAddressLine1="House # 34, Street twenty three Link Road Cavalary Ground"
											accountCity=" Toronto"
											accountProvince="ON"
											accountPostalCode="W3R4T5"
											companyInformation={
												t4SummaryReduceEIData &&
													t4SummaryReduceEIData.message &&
													t4SummaryReduceEIData.message.status_code !== 404
													? t4SummaryReduceEIData
													: undefined
											}
										/>
									</FlatStandardPanel>
									<Divider
										component="hr"
										sx={{ width: "68%", marginLeft: "16%", marginRight: "16%" }}
									/>
									<FlatStandardPanel
										title="T4 Slips Detail"
										testId={`${testId}-t4-slip-detial-panel`}
										leftSpacing={2}
										rightSpacing={2}
									>
										<T4SlipDetailPanel />
									</FlatStandardPanel>
									<Divider
										component="hr"
										sx={{ width: "68%", marginLeft: "16%", marginRight: "16%" }}
									/>
									<FlatStandardPanel
										title="Statutory Contributions"
										testId={`${testId}-statutory-contributions-panel`}
										leftSpacing={2}
										rightSpacing={2}
									>
										<EmployerDetailPanel formMethods={formMethods} />
									</FlatStandardPanel>
									<Divider
										component="hr"
										sx={{ width: "68%", marginLeft: "16%", marginRight: "16%" }}
									/>
									<FlatStandardPanel
										title="Difference"
										testId={`${testId}-difference-panel`}
										leftSpacing={2}
										rightSpacing={2}
									>
										<DifferencePanel />
									</FlatStandardPanel>
									<Divider
										component="hr"
										sx={{ width: "68%", marginLeft: "16%", marginRight: "16%" }}
									/>
									<FlatStandardPanel
										title="Total Balance"
										testId={`${testId}-total-balance-panel`}
										leftSpacing={2}
										rightSpacing={2}
									>
										<TotalBalancePanel />
									</FlatStandardPanel>
									{/* <TaxSlipFilingResourceSelectionPanel /> */}

									<Grid container>
										<Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
										<Grid size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
											<Paper variant="outlined">
												<FlatStandardPanel
													title="Select Resources"
													testId="company-persons-panel"
												// leftSpacing={2}
												// rightSpacing={2}
												>
													<EnhancedDropDownRHFWithLabel
														selectName="valueOfTransmitter"
														label="Transmitter"
														labelPosition={LabelPosition.Left}
														// items={[{ label: "Babar", value: "64abebd533ed876a2a4a5b0a" }]}
														items={
															transmitterDDL && transmitterDDL.message
																? []
																: transmitterDDL
																	? transmitterDDL
																	: []
														}
														testId="transmitter"
														required
													/>
													<EnhancedDropDownRHFWithLabel
														selectName="slipType"
														label="XML Type"
														labelPosition={LabelPosition.Left}
														items={[
															{ label: "Original", value: 400 },
															{ label: "Amended", value: 200 },
															{ label: "Cancelled", value: 300 },
															{ label: "Additional", value: 100 },
														]}
														testId="xmlType"
														selectedItem={selectedType}
														onSelectionChangeHandler={
															onSlipTypeSelectionChangeHandler
														}
													/>
													<EnhancedTextAreaFieldRHF
														id="notes"
														testId="notes"
														label="Notes"
														maxRows={15}
														minRows={5}
														labelPosition={LabelPosition.Left}
													/>
													<Box sx={{ pt: 2 }}></Box>
													<EnhancedDivider testId="transmitter-divider" />
													<Box sx={{ pb: 2 }}></Box>
													<EnhancedDropDownRHFWithLabel
														selectName="valueOfIssuer"
														label="Issuer"
														labelPosition={LabelPosition.Left}
														// items={[{ label: "Babar", value: "64abebd533ed876a2a4a5b0a" }]}
														items={
															issuerDDL && issuerDDL.message
																? []
																: issuerDDL
																	? issuerDDL
																	: []
														}
														// selectedItem='646df8e0670529a84abf83df'
														testId="transmitter"
														required
														onSelectionChangeHandler={
															onIssuerSelectionChangeHandler
														}
													/>
													<TaxSlipSummaryDataInput
														id="ownerSin1"
														label="SIN 1 of the proprietor(s) or principal owner(s)"
														boxNumber="74"
														textfield={true}
													/>
													<TaxSlipSummaryDataInput
														id="ownerSin2"
														label="SIN 2 of the proprietor(s) or principal owner(s)"
														boxNumber="75"
														textfield={true}
													/>
													<Box sx={{ pt: 2 }}></Box>
													<EnhancedDivider testId="transmitter-divider" />
													<Box sx={{ pb: 2 }}></Box>
													<Grid
														container
														columnSpacing={0}
														size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
													>
														<Grid
															size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}
															sx={{ textAlign: "left", paddingTop: 1 }}
														>
															<InputLabel>
																<Typography variant="subtitle2">
																	Person to contact about this return{" "}
																	<RequiredAsterisk />
																</Typography>
															</InputLabel>
														</Grid>
														<Grid
															size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}
															sx={{ textAlign: "center", paddingTop: 1 }}
														>
															<InputLabel>
																<Typography variant="subtitle2">76</Typography>
															</InputLabel>
														</Grid>
														<Grid size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}>
															<EnhancedDropDownRHF
																selectName="valueOfContactPerson"
																// label="Person to contact about this return"
																// labelPosition={LabelPosition.Left}
																// items={[{ label: "Babar", value: "64abebd533ed876a2a4a5b0a" }]}
																items={
																	contactPersonDDL && contactPersonDDL.message
																		? []
																		: contactPersonDDL
																			? contactPersonDDL
																			: []
																}
																testId="contactPerson"
																// required
																onSelectionChangeHandler={
																	onContactPersonSelectionChangeHandler
																}
															/>
														</Grid>
														<Grid
															size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}
															sx={{ textAlign: "left", paddingTop: 2 }}
														>
															<InputLabel>
																<Typography variant="subtitle2">
																	Phone number (Ext.)
																</Typography>
															</InputLabel>
														</Grid>
														<Grid
															size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}
															sx={{ textAlign: "center", paddingTop: 2 }}
														>
															<InputLabel>
																<Typography variant="subtitle2">78</Typography>
															</InputLabel>
														</Grid>
														<Grid size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}>
															<RHookFormTextField
																// id="phone-number"
																id="phone1"
																testId="phone-number"
																readOnly
															/>
														</Grid>
													</Grid>
												</FlatStandardPanel>
											</Paper>
										</Grid>
										<Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
									</Grid>
									<Spacer y={4} x={4} />
								</Paper>
							</SingleColumnLayout>
						</Grid>
					</Grid>
				</form>
			</FormProvider>
			{/* invoice dialogu open if any transaction is unPaid */}
			<EnhancedDialog
				dialogTitle="Invoice(s) Due"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseHandler}
				open={openInvoiceDialog}
				dialogContent={
					<InvoiceDialogPanel
						invoiceData={invoiceData}
						onUnPaidClickHandler={onUnPaidClickHandler}
						onClickInvoiceNoHandler={onClickInvoiceNoHandler}
					/>
				}
				dialogAction={
					<Grid>
						<Button autoFocus variant="contained" onClick={onCloseHandler}>
							Cancel
						</Button>
					</Grid>
				}
			/>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`${testId}-snackbar`}
				open={snackbarData.open}
				autoHide={snackbarData.autoHide}
			/>
		</Grid>
	);
};
